import { Component } from '@angular/core';
import { GoBackService } from '@shared/services/go-back.service';
import { UiAtomTextComponent } from '@shared/components/atoms/ui-atom-text/ui-atom-text.component';
import { UiAtomButtonComponent } from '@shared/components/atoms/ui-atom-button/ui-atom-button.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-not-found',
  imports: [UiAtomTextComponent, UiAtomButtonComponent, TranslatePipe],
  templateUrl: './not-found.html',
  styleUrl: './not-found.scss',
})
export class NotFound {
  //protected readonly texts = TextsBasics;
  //protected readonly textsNotFound = TextsNotFound;

  constructor(protected goBackService: GoBackService) {}

  protected handleGoBackClick() {
    // Usar navegación jerárquica según rol y contexto
    this.goBackService.goBackHierarchical();
  }
}
